import gql from 'graphql-tag'
export const MUTATION__ADD_MEMBER_TO_STUDENTGROUP = gql`mutation AddStudentGroupMember($studentUuid: String!, $groupUuid: String!) {
  hasBeenAdded: addStudentGroupMember(student_uuid: $studentUuid, group_uuid: $groupUuid)
}`;
